import {
  Component, h, JSX, Host, Prop, Watch,
} from '@stencil/core';
import { store } from '../utils/store';
import { I18NKey } from '../types/I18N';


@Component({
  tag: 'belimo-i18n',
  shadow: false,
})
export class I18n {
  @Prop({ mutable: true }) messageId: I18NKey | string | null = null;

  @Prop() fallbackToKey = false;

  @Watch('messageId')
  public readKey(newValue: I18NKey | string | null): void {
    this.messageId = newValue;
  }

  public async componentWillLoad(): Promise<void> {
    this.readKey(this.messageId);
  }

  public render(): JSX.Element {
    return (<Host>{this.getContent(this.messageId)}</Host>);
  }

  private getContent(messageId: I18NKey | string | null): string {
    if (messageId === null) {
      return '';
    }
    const fallback = this.fallbackToKey ? messageId : `_${messageId}_`;
    const config = store.state.config;
    if (config) {
      const {i18n} = config;
      return i18n[messageId as I18NKey] || fallback;
    }
    return fallback;
  }
}
